import { AuthService } from 'src/app/services/auth.service';
import { DatabaseService } from './../../../services/database.service';
import { Equipe } from './../../../models/equipe.model';
import { HelpersService } from 'src/app/services/helpers.service';
import { Component, OnInit } from '@angular/core';
import { UserProfile, User } from '../../../models/user.model';

@Component({
  selector: 'app-resumo-equipe',
  templateUrl: './resumo-equipe.component.html',
  styleUrls: ['./resumo-equipe.component.css']
})
export class ResumoEquipeComponent implements OnInit {

  private equipeId: string = this.helper.getEquipeId();
  private equipe: Equipe;
  private profile: UserProfile;
  showSpinner = true;

  constructor(private auth: AuthService,
              public helper: HelpersService,
              private database: DatabaseService) { }

  ngOnInit(): void {
    this.database.getEquipe(this.equipeId)
    .then( rawData => rawData.subscribe( (data: Equipe[]) => {
      this.equipe = data.find(e => e.equipeId === this.equipeId);

      this.auth.getUser.then((user: User) => {
        this.profile = user.user;
        if (this.equipe.membros.findIndex(m => m.uid === this.profile.uid) > -1) {
          this.showSpinner = false;
        } else {
          this.helper.routeToEquipes();
        }
      });
    }));
  }

  get equipeNome(): string {
    return this.equipe.nomeEquipe;
  }

  get membrosEquipe(): UserProfile[] {
    return this.equipe.membros;
  }

  get tituloDesafioEscolhido(): string {
    return this.equipe.desafioEscolhido.titulo;
  }

  get descricaoDesafioEscolhido(): string {
    return this.equipe.desafioEscolhido.descricao;
  }

  sairDaEquipe() {
    const membroIndex = this.equipe.membros.findIndex(m => m.uid === this.profile.uid);
    this.equipe.membros.splice(membroIndex, 1);
    this.database.updateEquipe(this.equipe);
    this.helper.routeToEquipes();
  }

  escolherDesafio() {
    this.helper.routeToEscolhaDesafio(this.equipeNome);
  }

  fazerEntregas() {
    this.helper.routeToEntregas(this.equipeNome);
  }
}
